import React from "react";
import {
  Card,
  CardHeader,
  Row,
  Col,
  CardBody,
  Button
} from "shards-react";
import { Link } from "react-router-dom";
import { TiEdit,TiDeleteOutline,TiEyeOutline } from "react-icons/ti";
import SupplierDataService from "../../services/supplier.service";
import { FcPlus, FcDownload } from "react-icons/fc";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import {actions as AppActions} from "../../_stores/app.store";
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import * as XLSX from "xlsx";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import authStore from "../../_stores/auth.store";

const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const EGYPT = process.env.REACT_APP_MARKET === "EGYPT";

  const perPage = 10;
  const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const EXCEL_EXTENSION = ".xlsx";

class ViewProjectSupplier extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      supplierList:[]
    };
    this.aggridRef = React.createRef();

    this.retrieveSupplier = this.retrieveSupplier.bind(this);
    this.deleteSupplier = this.deleteSupplier.bind(this);
    this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
  }

  componentDidMount() {
    this.retrieveSupplier();
  }

  retrieveSupplier(){
    AppActions.setLoading(true);
  	SupplierDataService.getByProject(this.props.projectId).then((response) => {
      //console.log(response.data.data);
		AppActions.setLoading(false);
      this.setState({
				supplierList:response.data.data,
			})
  	}); 
    
	}

  deleteSupplier(id){
    SupplierDataService.delete(id).then((response) => {
        this.retrieveSupplier();
				this.props.notify("success", "Supplier Deleted");
			})
			.catch((error) => {
				const message =
					(error.response &&
						error.response.data &&
						error.response.data.message) ||
					error.message ||
					error.toString();
				this.setState({
					message: message,
				});
				this.props.notify("error", message);
        AppActions.setLoading(false);
			});
      
  }

  onPageSizeChanged(e) {
    let value = e.target.value;
    this.aggridRef.current.api.paginationSetPageSize(Number(value));
  };

  exportToExcel() {
    const { supplierList } = this.state;
    // console.log(supplierList);
    const sheetdata = [];
    sheetdata.push(["Supplier Name", "Supplier Code", "Supplier EPR", "Address", "City", "Modified By", "Updated Date"]);
    for (let i = 0; i < supplierList.length; i++) {
      const conItem = supplierList[i];
      sheetdata.push([conItem.supplierName, conItem.supplierCode,conItem.supplierERP, conItem.supplierAddress, conItem.supplierCity, !(conItem.modifiedBy && conItem.modifiedBy.name) ? "admin" : conItem.modifiedBy.name , moment(new Date(conItem.updatedAt)).format("DD/MM/yyyy hh:mm:ss A")]);
    }
    this.prepWorkbookFromJson(sheetdata);
  }

  prepWorkbookFromJson(sheetdata) {
    const worksheet = XLSX.utils.json_to_sheet(sheetdata, {
      skipHeader: true,
    });
    const wsColWidths = sheetdata[0].map((th) => ({ wch: th.length + 1 }));
    worksheet["!cols"] = wsColWidths;
    const workbook = {
      Sheets: { ["Sheet1"]: worksheet },
      SheetNames: ["Sheet1"],
    };
    const excelBuffer = XLSX.write(workbook, {
      type: "buffer",
      bookType: "xlsx",
    });
    this.createUrlFromBlob(excelBuffer);
  }

  createUrlFromBlob(bufferData) {
    const blob = new Blob([bufferData], { type: EXCEL_TYPE });
    const objurl = URL.createObjectURL(blob);
    this.downloadFile(objurl, "Supplier_Master_" + new Date().getTime() + EXCEL_EXTENSION);
    URL.revokeObjectURL(objurl);
  }

  downloadFile(objurl, filename) {
    const anchor = document.createElement("a");
    anchor.href = objurl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  render() {
    const {
      supplierList
    } = this.state;

    const columnDefs = [
      {headerName: "Supplier Name", field: "supplierName", filter: true, sortable:true, width:"280"},
      {headerName: "Suppliper Code", field: "supplierCode",filter: true, sortable:true, width:"150"},
      
      {headerName: "ERP", field: "supplierERP",filter: true,  sortable:true, width:"250"},
      {headerName: "Address", field: "supplierAddress",filter: true,  sortable:true, width:"300"},
      {headerName: "City", field: "supplierCity",filter: true,  sortable:true, width:"100"},
      {headerName: "Modified By", field: "modifiedBy.name",filter: true,  sortable:true, width:"120",
        cellRendererFramework: (data) => {
          return (!data.value ? "admin" :  data.value)
          } 
      },
      {headerName: "Updated At", field: "updatedAt",filter: true,  sortable:true, width:"160",
          cellRendererFramework: (data) => {
            return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
          } 
      },
      {headerName: "action", field:"id", width:"100",
        cellRendererFramework: (data) => {
           return <>
                <Link title="Details" className="text-primary mr-2" to={"/project/"+this.props.projectId+"/supplier/"+data.value+"/detail"}><TiEyeOutline  size="20" /></Link>
                <Link title="Edit" className="text-success mr-2" to={"/project/"+this.props.projectId+"/supplier/"+data.value+"/edit"}><TiEdit  size="20" /></Link>
                {authStore.getState().auth_reducer.user.role === "superadmin" && (
                  <span className="text-danger cursor-pointer" title="delete" onClick={() => this.deleteSupplier(data.value)}><TiDeleteOutline size="20" /></span>
                )}
            </>
        }
        
      }
    ]

    if(SAUDI || EGYPT){
      columnDefs.splice(2, 0, {headerName: "DS Code", field: "dsCode",filter: true, sortable:true, width:"150"})
    }

    return (
      <Row>
        <Col>
          <Card small className="mb-4">
            <CardHeader className="border-bottom">
              <h6 className="m-0">
                Project Supplier Configuration
                <Link className="btn btn-primary ml-4" to={"/project/"+this.props.projectId+"/supplier/create"}><FcPlus /> Create New Supplier Configuration</Link>
                <Button variant="primary" className="ml-3 btn btn-success" onClick={this.exportToExcel}>
                    <FcDownload /> Export Supplier Data
                  </Button>
              </h6>
            </CardHeader>
            <CardBody className="p-0 pb-3">
                  <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
                    <div className="example-header">
                      Page Size: &nbsp;
                      <select onChange={this.onPageSizeChanged} id="page-size">
                        <option value="10" selected={true}>
                          10
                        </option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                      </select>
                    </div>
                    <AgGridReact
                        ref={this.aggridRef}
                        pagination={true}
                        rowHeight={50}
                        paginationPageSize={perPage}
                        columnDefs={columnDefs}
                        rowData={supplierList}>

                    </AgGridReact>
                  </div>
               
            </CardBody>
          </Card>
        </Col>
      </Row>
    )
  }
}

export default ViewProjectSupplier;
